import request from '@/utils/http/request'

/**
 * 儲值配置
 * @returns 
 */
export async function points_config() {
  return await request.post('/points/config', {});
}


/**
 * 點數記錄
 * @returns 
 */
export async function members_points({ type, consType, pageNumber, pageSize }) {
  return await request.post('/members/points', {
    type, consType, pageNumber, pageSize
  });
}


/**
 * 儲值訂單創建
 * @returns 
 */
export async function recharges({ rechargeAmount }) {
  return await request.post('/recharges', {
    rechargeAmount
  });
}

/* 儲值結算確認 */
export async function orderRecharges({ orderId, tapPayPrime, phoneNumber, name, email }) {
  return await request.post(`/recharges/${orderId}`, {
    tapPayPrime, phoneNumber, name, email
  });
}

/* 轉點 */
export async function points_transfer(point) {
  return await request.post(`/points/transfer`, {
    point
  });
}

/* 轉點資訊 */
export async function points_transfer_info(code) {
  return await request.post(`/points/transfer/info/${code}`, {});
}

/* 轉點接收 */
export async function points_conformTransfer(code) {
  return await request.post(`/points/conformTransfer`, {
    code
  });
}


/**
  * 租場/課程等，下單
  * @returns {Object}
  */
export async function createOrder({
  scene,
  bookingId,
  timeSlotsIdArr,
  contactName,
  phoneNumber,
  ticketCount,
  identityType,
  teamTitle
}) {
  return await request.post(`/createOrder`, {
    scene,
    bookingId,
    timeSlotsIdArr,
    contactName,
    phoneNumber,
    source: 2,
    ticketCount,
    identityType,
    teamTitle
  });
}





/**
  * 票夾接口
  * @param {*} param0.sportType - 球種類型
  * @param {*} param0.serviceType - 服務類型
  * @param {*} param0.orderStatus - 服務類型
  * @param {*} param0.date -選擇時間
  * @returns {Object} - 票夾分頁數據
  */
export async function tickets({ sportType, serviceType, orderStatus, date, isDueSoon, pageNumber, pageSize }) {
  return await request.post('/tickets', {
    sportType, serviceType, orderStatus, date, isDueSoon, pageNumber, pageSize
  });
}


/**
* 票夾詳情
* @returns {Object}
*/
export async function orders(orderId) {
  return await request.post(`/orders/${orderId}`, {});
}

/* 接收轉票 */
export async function orders_confirmTransfer({ qrCode, teamTitle, contactName, memberPhone, height, age, dietaryRequirements }) {
  return await request.post(`/orders/confirmTransfer`, {
    qrCode, teamTitle, contactName, memberPhone, height, age, dietaryRequirements
  });
}


/* 轉票 */
export async function orders_transfer(orderId) {
  return await request.post(`/orders/transfer/${orderId}`, {});
}

/* 取消轉票 */
export async function orders_cancelTransfer(orderId) {
  return await request.post(`/orders/cancelTransfer/${orderId}`, {});
}
/* 取消訂單 */
export async function orders_cancel(orderId) {
  return await request.post(`/orders/cancel/${orderId}`, {});
}



/* 票夾訂單統計 */
export async function orders_statistics() {
  return await request.post(`/orders/statistics`, {});
}


export async function pay_callback_tappay() {
  return await request.get(`/pay/callback/tappay`, {});
}


export async function pay_config({ payType }) {
  return await request.post(`/pay/config`, { payType });
}

export async function recharges_tapPayOrder_query({ orderId }) {
  return await request.post(`/api/recharges/tapPayOrder/query/${orderId}`, {});
}



